var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23406 0.25L3.01734 1.00359L11.4924 7.1579V2.25957L15.1426 4.89713V14.61L3.01734 5.86005V12.3074L4.23406 13.2285V8.33014L15.1426 16.2428L16.3173 15.5311V4.14354L11.4924 0.626794L10.3176 1.38038V4.6878L4.23406 0.25Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9258 5.60885L12.7091 4.8134V9.62799L1.75867 1.71531L0.5 2.4689V13.8565L5.36686 17.3732L6.58358 16.6196V13.3541L12.7091 17.75L13.9258 16.9964L5.36686 10.8002V15.7404L1.75867 13.1447V3.34809L13.9258 12.14V5.60885Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderLogo);
export default __webpack_public_path__ + "static/media/loaderLogo.fc003c7da84f629ea30fbbd448d0e29f.svg";
export { ForwardRef as ReactComponent };